const RECAPTCHA_SCRIPT_ID = "google-recaptcha-enterprise-script";
const RECAPTCHA_ONLOAD_CALLBACK = "onRecaptchaEnterpriseLoaded";

let recaptchaScriptPromise = null;

function loadRecaptchaScript() {
    if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {
        return Promise.resolve(window.grecaptcha.enterprise);
    }

    if (recaptchaScriptPromise) {
        return recaptchaScriptPromise;
    }

    recaptchaScriptPromise = new Promise((resolve, reject) => {
        const existingScript = document.querySelector('script[src*="www.google.com/recaptcha/"]');
        if (existingScript && existingScript.parentNode) {
            existingScript.parentNode.removeChild(existingScript);
        }

        window[RECAPTCHA_ONLOAD_CALLBACK] = function () {
            resolve(window.grecaptcha.enterprise);
        };

        const script = document.createElement("script");
        script.id = RECAPTCHA_SCRIPT_ID;
        script.async = true;
        script.defer = true;
        script.onerror = reject;
        script.src = "https://www.google.com/recaptcha/enterprise.js?onload=" + RECAPTCHA_ONLOAD_CALLBACK + "&render=explicit";
        document.head.appendChild(script);
    });

    return recaptchaScriptPromise;
}

function renderCheckboxRecaptcha(recaptcha, siteKey, containerId, action) {
    const container = document.getElementById(containerId);
    if (!container) {
        return null;
    }

    const existingWidgetId = container.getAttribute("data-recaptcha-widget-id");
    if (existingWidgetId !== null) {
        return Number(existingWidgetId);
    }

    let widgetId = null;
    const options = {
        sitekey: siteKey,
    };
    if (action) {
        options.action = action;
    }
    widgetId = recaptcha.render(containerId, options);
    container.setAttribute("data-recaptcha-widget-id", widgetId);
    return widgetId;
}

export function renderRecaptcha(siteKey, containerId, action) {
    if (!siteKey || typeof window === "undefined" || typeof document === "undefined") {
        return Promise.resolve(null);
    }

    return loadRecaptchaScript().then((recaptcha) => {
        return renderCheckboxRecaptcha(recaptcha, siteKey, containerId, action);
    }).catch(() => {
        recaptchaScriptPromise = null;
        return null;
    });
}

export function getInvisibleRecaptchaToken(siteKey, containerId) {
    return renderRecaptcha(siteKey, containerId).then((widgetId) => {
        if (widgetId === null || !window.grecaptcha || !window.grecaptcha.enterprise) {
            return null;
        }
        return window.grecaptcha.enterprise.getResponse(widgetId);
    });
}

export function resetRecaptcha(siteKey, containerId) {
    return renderRecaptcha(siteKey, containerId).then((widgetId) => {
        if (widgetId !== null && window.grecaptcha && window.grecaptcha.enterprise) {
            window.grecaptcha.enterprise.reset(widgetId);
        }
    });
}

export function hideRecaptchaBadge() {
    const badge = document.querySelector(".grecaptcha-badge");
    if (badge) {
        badge.style.visibility = "hidden";
    }
}
